import { FC, ReactNode } from 'react';
import { Text } from '@qga/roo-ui/components';

import withProps from '../withProps';

interface SubtextProps {
  children: ReactNode;
}

const Subtext = withProps(({ ...props }) => ({
  color: 'greys.steel',
  fontSize: 'sm',
  ...props,
}))(Text) as FC<SubtextProps>;

export default Subtext;
